export default __webpack_public_path__ + "static/media/sensor.4d2c83de.svg";